import type { CV, CVListItemDto, FullCV, FullCVWithTemplate } from '@cibli/shared';

import { AxiosRequestConfig } from 'axios';

import api from './api';

export const getUserCVs = async (search?: string): Promise<CVListItemDto[]> => {
  return await api.get<CVListItemDto[]>('/users/me/cvs', {
    params: search ? { search } : undefined,
  });
};

export const fetchCV = async (id: string): Promise<FullCVWithTemplate> => {
  return await api.get<FullCVWithTemplate>(`/cv/${id}`);
};

export const downloadCV = async (id: string): Promise<Blob> => {
  const config: AxiosRequestConfig = {
    responseType: 'blob',
    headers: { Accept: 'application/pdf' },
  };
  const response = await api.get<Blob>(`/cv/${id}/download`, config);
  if (response.type !== 'application/pdf') {
    console.warn(`Unexpected content type: ${response.type}`);
  }
  return response;
};

export const sendCVBySMS = async (id: string): Promise<{ status: 'ok' }> => {
  return await api.post<{ status: 'ok' }, void>(`/cv/${id}/send-sms`, undefined);
};

export const sendCVByEmail = async (id: string): Promise<{ status: 'ok' }> => {
  return await api.post<{ status: 'ok' }, void>(`/cv/${id}/send-email`, undefined);
};

export const translateCV = async (
  cvId: string,
): Promise<{
  cvTranslated: CV;
  fullCvTranslated?: FullCV;
}> => {
  return await api.patch<{ cvTranslated: CV; fullCvTranslated?: FullCV }, unknown>(
    `/cv/${cvId}/translate`,
    {},
  );
};

export const deleteCV = async (cvId: string): Promise<void> => {
  await api.delete<void>(`/cv/${cvId}`);
};
